/* eslint-disable max-len */
/* Note: this file is generated by "npm run template", please dont modify this file directly */
/* -- instead, you should modify "static-files/gant-legacy/package.json" and run "npm run template" */
import { ResultFile } from "@gant-lowcode/lowcode-types";

export default function getFile(): [string[], ResultFile] {
  return [
    ["."],
    {
      name: "package",
      ext: "json",
      content:
        '{\n  "private": true,\n  "scripts": {\n    "start": "umi dev",\n    "build": "umi build",\n    "postinstall": "umi generate tmp",\n    "prettier": "prettier --write \'**/*.{js,jsx,tsx,ts,less,md,json}\'",\n    "test": "umi-test",\n    "test:coverage": "umi-test --coverage"\n  },\n  "gitHooks": {\n    "pre-commit": "lint-staged"\n  },\n  "lint-staged": {\n    "*.{js,jsx,less,md,json}": [\n      "prettier --write"\n    ],\n    "*.ts?(x)": [\n      "prettier --parser=typescript --write"\n    ]\n  },\n  "dependencies": {\n    "@ant-design/pro-layout": "^6.5.0",\n    "react": "17.x",\n    "react-dom": "17.x",\n    "umi": "^3.5.43"\n  },\n  "devDependencies": {\n    "@types/react": "^17.0.0",\n    "@types/react-dom": "^17.0.0",\n    "@umijs/preset-react": "1.x",\n    "@umijs/test": "^3.5.43",\n    "lint-staged": "^10.0.7",\n    "prettier": "^2.2.0",\n    "typescript": "^4.1.2",\n    "yorkie": "^2.0.0"\n  }\n}\n',
    },
  ];
}
